import { cn } from '@lib-atria/ui-toolkit';
import { MaterialIcons } from '../icons';

type Props = {
  selected: boolean;
  onSelect: () => void;
};

export function AppointmentsCardPendingSidebar({ selected, onSelect }: Props) {
  return (
    <div
      className={cn(
        'rounded bg-white flex flex-col justify-center items-center cursor-pointer h-[68px] w-[68px] p-2',
        selected && 'bg-neue-kelp-400'
      )}
      onClick={onSelect}
    >
      <MaterialIcons
        name='format_list_bulleted'
        className={cn('text-[24px]', selected && 'text-white', !selected && 'text-neue-kelp-400')}
      />
    </div>
  );
}
